module.exports = __webpack_public_path__ + "img/logo-new.e62da783.png";